import React, { createContext, useContext, useState, useEffect } from 'react';

const Context = createContext();

export const useProduct = () => useContext(Context);

export const ProductContext = ({ children, product }) => {
  const [currentVariant, setCurrentVariant] = useState(
    product.variants.find((v) => v.id === product.variantBySelectedOptions.id) || null,
  );

  const [selectedOptions, setSelectedOptions] = useState(
    product.variantBySelectedOptions.selectedOptions.map((option) =>
      option.name.toLowerCase().includes('size')
        ? {
            ...option,
            value: null,
          }
        : option,
    ),
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const variantId = searchParams.get('variant');
    if (variantId) {
      const variant = product.variants.find((v) => v.id.includes(variantId));
      setSelectedOptions(variant.selectedOptions);
    }
  }, []);

  useEffect(() => {
    const variant = product.variants.find((v) => JSON.stringify(v.selectedOptions) === JSON.stringify(selectedOptions));
    if (variant) {
      setCurrentVariant(variant);
    }
  }, [selectedOptions]);

  return (
    <Context.Provider
      value={{
        product,
        currentVariant,
        setCurrentVariant,
        selectedOptions,
        setSelectedOptions,
      }}
    >
      {children}
    </Context.Provider>
  );
};
